// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"89dd6d20","596":"9182b580","787":"175bcbb5"}[chunkId] + ".chunk.js";
};